import { render, staticRenderFns } from "./FrameworkConfiguration.vue?vue&type=template&id=ddfca498"
import script from "./FrameworkConfiguration.vue?vue&type=script&lang=js"
export * from "./FrameworkConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports